<template>
  <div class="hm-home">
    <div class="table-panel  mb10 ">
      <div class="flex flex-between item-center">
        <div class="form-wrapper flex flex-1 flex-wrap flex-end ">
          <el-cascader
            clearable
            ref="cascader"
            v-model="selectedStore"
            :props="props"
            :show-all-levels="false"
            size="small"
            placeholder="请选择机构"
            class="mr10"
          ></el-cascader>
          <el-select
            size="small"
            clearable
            filterable
            placeholder="请选择被考核人"
            v-model="searchConditons.employeeId"
            style="width: 150px"
            class="mr10"
          >
            <el-option
              v-for="(item, index) in employeeList"
              :key="index"
              :label="item.realname"
              :value="item.employeeId"
            ></el-option>
          </el-select>
          <el-select
            size="small"
            clearable
            filterable
            placeholder="请选择确认状态"
            v-model="searchConditons.taskStatusDesc"
            style="width: 150px"
            class="mr10"
          >
            <el-option label="已确认" value="confirmed"></el-option>
            <el-option label="待确认" value="notConfirmed"></el-option>
          </el-select>
          <el-button size="small" type="primary" @click="search"
            >查询</el-button
          >
        </div>
      </div>
    </div>
    <div class="card">
      <div class="caption flex item-center mb20 bold">{{ taskName }}</div>
      <div class="table mb20">
        <el-table stripe border :data="list" style="width: 100%">
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            width="50"
            label="序号"
            :index="index => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="shopName"
            label="机构"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="employeeName"
            label="被考核人"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="groupName"
            label="考核组"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="自动评分分数"
          >
            <template slot-scope="scope">
              <span style="color: #00CECC">{{ scope.row.autoTaskScore }}</span>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="手动评分分数"
          >
            <template slot-scope="scope">
              <span style="color: #5F23F5">{{
                scope.row.manualTaskScore
              }}</span>
            </template>
          </el-table-column>
          <el-table-column header-align="center" align="center" label="总分">
            <template slot-scope="scope">
              <span class="success">{{ scope.row.taskScore }}</span>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="考核等级"
          >
            <template slot-scope="scope">
              <span class="success">{{ scope.row.levelPointName }}</span>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="levelName"
            label="确认状态"
          >
          </el-table-column>
        </el-table>
      </div>
      <div class="text-center">
        <el-pagination
          background
          layout="total,sizes,  prev, pager, next, jumper"
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          :current-page="currentPage"
          ref="pagination"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      searchConditons: {
        taskStatusDesc: "",
        employeeId: "",
        memberType: "member"
      },
      taskName: "",
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      selectedStore: [],
      couponLevelList: [],
      storeList: [],
      groupList: [],
      levelList: [],
      employeeList: [],
      props: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: async (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            const res = await this.$store.dispatch("queryOrganizationTree", {
              pageNo: 1,
              pageSize: 999,
              loginType: "store"
            });
            res.result.records.forEach(v => {
              v.leaf = Boolean(!v.isParent);
              v.value = v.orgCode;
              v.label = v.departName;
            });
            resolve(res.result.records);
          } else {
            const res = await this.$store.dispatch(
              "queryOrganizationListByParent",
              {
                parentId: data.treeStruct
              }
            );
            if (res.code === "0" && res.result) {
              res.result.forEach(v => {
                v.leaf = Boolean(!v.isParent);
                v.value = v.orgCode;
                v.label = v.departName;
              });
              resolve(res.result);
            } else {
              resolve([]);
            }
          }
        }
      }
    };
  },
  created() {},
  mounted() {
    this.queryList();
    this.queryStoreList();
    this.queryEmployee();
  },
  computed: mapGetters([]),
  watch: {},
  methods: {
    toRating() {},
    viewDetails(row) {
      this.$router.push({
        name: "taskScoreDetails",
        query: {
          id: row.id
        }
      });
    },
    async queryList() {
      const orgCode =
        this.selectedStore && this.selectedStore.length
          ? this.selectedStore[this.selectedStore.length - 1]
          : "";
      const params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        orgCode
      };
      Object.assign(params, this.searchConditons);
      const { result } = await this.$store.dispatch(
        "queryTaskResultList",
        params
      );
      const { records, total } = result;
      this.list = records;
      this.taskName = this.list.map(v => v.taskName)[0];
      this.total = total;
    },
    async queryStoreList() {
      let params = {
        pageSize: 99999,
        pageNo: 1
      };
      const { result } = await this.$store.dispatch("queryShopList", params);
      this.storeList = result.records;
    },
    async queryEmployee() {
      const { result } = await this.$store.dispatch("queryEmployee", {
        pageNo: 1,
        pageSize: 9999,
        loginType: "store",
        workingState: "yes"
      });
      this.employeeList = result.records;
    },
    switchTab(e) {
      this.activeTab = e;
      this.currentPage = 1;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    }
  }
};
</script>
<style lang="scss" scoped>
.table-panel {
  background: #fff;
  padding: 15px;
}

.card {
  background: #fff;
  padding: 15px;
}

.caption {
  font-size: 16px;
  color: #222;
  &::before {
    content: "";
    width: 4px;
    height: 16px;
    border-radius: 2px 0px 2px 0px;
    background: #e50065;
    margin-right: 5px;
  }
}
</style>
